export class BodyHelper {
  static addClass(className: string): void {
    document.body.classList.add(className);
  }

  static removeClass(className: string): void {
    document.body.classList.remove(className);
  }
}
